'use client';

var translations = {
    'Your session expired for one of two reasons:': 'Phiên làm việc của bạn đã hết hạn vì một trong hai lý do:',
    "You've been active for a long time.": 'Bạn đã hoạt động trong một thời gian dài.',
    "You've signed out on another device.": 'Bạn đã đăng xuất trên một thiết bị khác.',
    'Ready to log back in?': 'Bạn đã sẵn sàng để đăng nhập lại chưa?',
    'Stay logged out': 'Đăng xuất',
    'Login to continue': 'Đăng nhập để tiếp tục'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
